var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalysisChart',{attrs:{"endpoint":"web/get-fcr-analysis","data-key":"fcr","standard-key":"standard_fcr","series-label":"FCR","standard-label":"Standard FCR","yaxis-title":"Ratio"}})}
var staticRenderFns = []

export { render, staticRenderFns }